const VARIANT_CLASS = {
  primary: "admin-btn--primary",
  secondary: "admin-btn--secondary",
  ghost: "admin-btn--ghost",
  danger: "admin-btn--danger",
  link: "admin-btn--link",
  nav: "admin-btn--nav",
};

export default function AdminBtn({
  variant = "secondary",
  className = "",
  children,
  type = "button",
  ...props
}) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.secondary;

  return (
    <button
      type={type}
      className={`admin-btn ${variantClass}${className ? ` ${className}` : ""}`}
      {...props}
    >
      {children}
    </button>
  );
}
